<template>
<div class="wrapper">

    <div class="mobile-head">
       <a href="javascript:;" class="mlogo" @click="goCate_('home')"><img :src="setting.siteLogo"/></a>
        <div class="wqs-search-btn" @click="goSearch_"></div>
       <div class="open-btn" @click="changeMobile">
           <i></i>
           <i></i>
           <i></i>
           <i></i>
       </div>
    </div>
    <div class="mobile-head-box"></div>


    <div class="mobile-lay-bg" :class="mobileTab"></div>
    <div class="mobile-lay-close" :class="mobileTab" @click="changeMobile"></div>
    <div class="mobile-lay" :class="mobileTab">
        <dl>
            <dt>
                <a href="javascript:;" class="mobile-a" @click="goCate_('home')">首页</a>
                <i class="mobile-tab" style="display: inline;"></i>
            </dt>
        </dl>

        <dl v-for="(item,index) in cmsCategoryList">
            <dt>
                <a href="javascript:;" class="mobile-a" @click="goCate_(item)">{{item.categoryName}}</a>
                <i class="mobile-tab" style="display: inline;"></i>
            </dt>
        </dl>
    </div>




    <div class="common-header">
        <div class="common-header-bg">
            <div class="logo" @click="goCate_('home')"><img :src="setting.siteLogo"></div>
            <div class="logo-right">
                <div class="menu">
                    <ul>
                        <li :class="getCateClass()" @click="goCate_('home')"><a href="javascript:;">首页</a></li>
                        <li v-for="(item,index) in cmsCategoryList" :class="getCateClass(item)"  @click="goCate_(item)"><a href="javascript:;">{{item.categoryName}}</a></li>
                    </ul>
                </div>
                <div class="tel-box">
                    <div class="icon"></div>
                    <div class="tel">{{setting.phone1}}</div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>

</div>
</template>
<script>
import {post_} from '@/components/js/request'
import {settingInfo_, categoryTree_, goCate_, goAdv_,goSearch_} from '@/components/js/app'
export default {
    props: {
        topBarClass:{type:String,default:''},
        navClass:{type:String,default:''},
        isHome:{type:Boolean,default:false},

    },
    data() {
      return {
          mobileTab:'',
          currentCateId:0,
          categoryInfo:{},
          cmsCategoryList:[
              {"id":36, "categoryName": "产品中心"},
              {"id":45, "categoryName": "用户案例"},
              {"id":46, "categoryName": "关于我们"},
              {"id":47, "categoryName": "知识分享"},
              {"id":48, "categoryName": "伙伴聘请"}

          ],
          setting:{}
      }
    },

      created() {
          this.currentCateId = this.$route.query.cateId;
          this.$nextTick(()=>{
              this.categoryTree();
              this.settingInfo();
          })
      },
    methods : {
        goCate_,
        goAdv_,
        goSearch_,
        // 顶部导航
        categoryTree() {
            categoryTree_((res) => {
                if (res.code == 1) {
                     this.cmsCategoryList = res.data;
                     for (let x = 0; x < this.cmsCategoryList.length; x++) {
                       if (this.cmsCategoryList[x].id == 36) {
                           this.productCategory = res.data[x].children;
                       }
                     }

                    for (let i = 0; i < this.cmsCategoryList.length; i++) {


                      if (this.cmsCategoryList[i].id==this.currentCateId) {
                          this.categoryInfo = this.cmsCategoryList[i];
                          return;
                      }

                      if (this.cmsCategoryList[i].children) {
                          let child = this.cmsCategoryList[i].children;

                          for (let j = 0; j < child.length; j++) {
                              if (child[j].id==this.currentCateId) {
                                  this.categoryInfo = child[j];
                                  break;
                              }


                              if (child[j].children) {
                                  for (let k = 0; k < child[j].children.length; k++) {
                                     if (child[j].children[k].id==this.currentCateId) {
                                         this.categoryInfo = child[j].children[k];
                                         break;
                                     }
                                 }
                              }
                          }
                      }
                  }


                 } else {
                     this.$message.error(res.message);
                 }
            }, true);
        },
        // 配置信息
       settingInfo() {
           settingInfo_((res) => {
               if (res.code == 1) {
                   this.setting = res.data;
               } else {
                   this.$message.error(res.message);
               }
           }, true);
        },
        changeMobile() {
           if (this.mobileTab=='') {
               this.mobileTab = 'on';
           } else {
               this.mobileTab = '';
           }
         },
        getCateClass(item) {
            if (!item) {
                return "";
            }
             if (item == 'home' && this.currentCateId == 0) {
                 return "on";
             } else if(this.categoryInfo.superIds) {

                 let split = this.categoryInfo.superIds.split(",");

                 if (split.indexOf(item.id + "") != -1) {
                     return "on";
                 }
             }
             return "";

         },
     }
}
</script>
<style scoped>
/*首页顶部*/

.mobile-head{display: none;}
.mobile-head-box{display: none;}
.mobile-lay-bg{display:none;}
.mobile-lay-close{display:none;}
.mobile-lay{display:none;}


.common-header{height: 60px;background: #e66b28;width: 100%;}
.common-header-bg{width: 100%;height: 100%;background: url("../../assets/img/head_bg.png") left top no-repeat;}
.common-header .logo{float: left;margin-left: 50px;margin-top: 10px;}
.common-header .logo img{width: 160px;height: 42px;object-fit: cover;}
.common-header .logo-right{float: right;display: flex;height: 100%;justify-content: center;align-items: center;}

.common-header .menu{margin-right: 40px;height: 100%;}
.common-header .menu ul{display: flex;height: 100%;}
.common-header .menu ul li{display: flex;height: 100%;justify-content: center;align-items: center;cursor: pointer;}
.common-header .menu ul li.on{background: url("../../assets/img/menu_bg.png") center center no-repeat;}

.common-header .menu ul li a{display: block;color: #FFFFFF;padding: 0px 20px;font-size: 16px;font-weight: 500;}
.common-header .tel-box{padding: 0px 100px 0px 40px;background: #FFFFFF;height: 100%;display: flex;justify-content: center;align-items: center;background: #FFFFFF;}
.common-header .tel-box .icon{background: url("../../assets/img/phone_icon.jpg") center center no-repeat;width: 31px;height: 31px;margin-right: 8px;}
.common-header .tel-box .tel{color: #e56b28;font-weight: 500;font-size: 16px;}




@media (max-width:1799px){

}
@media (max-width:1199px){

    .common-header .tel-box{display: none;}
}
@media (max-width:993px){
    .common-header{display: none;}
    .mobile-head-box{height: 56px;width: 100%;display: block;}
    .mobile-head {height: 56px;background: rgba(230,107,40,0.9);position: fixed;left: 0;top: 0;width: 100%;padding: 0 15px;z-index: 20;box-shadow: 0 1px 3px 2px rgb(0 0 0 / 6%);display: block;}
    .mlogo {float: left;}
   .mlogo img{height: 36px;width: auto;margin-top: 10px;vertical-align: middle;}
   .open-btn {width: 26px;height: 20px;position: absolute;right: 15px;top: 50%;margin-top: -9px;overflow: hidden;cursor: pointer;}
   .open-btn i {width: 30px;height: 2px;margin-bottom: 4px;background: #FFFFFF;display: block;}
   .open-btn i:nth-child(2) {width: 21px;}
   .open-btn i:nth-child(3) {width: 25px;}
   .open-btn i:nth-child(4) {width: 10px;}
    .wqs-search-btn{cursor: pointer;background: url("../../assets/img/index_search_bai.png") center center no-repeat;background-size:100%;width: 20px;height: 20px;position: absolute; right: 80px;top: 50%;margin-top:-8px;z-index: 1000000;}




    .mobile-lay-bg{ opacity: 0; position: fixed; z-index: 900; left: 0; top: 0; width: 100%; height: 100%; transition: all 0.5s ease-in-out; transition-delay: 0.4s; display: block; background:rgba(0,0,0,0.6); background-size:cover; visibility:hidden;}
    .mobile-lay{ position: fixed; height: 100%; left: 36%; top: 0px; right: 0px; bottom: 0px; z-index: 950; overflow-y: auto; color: #fff; font-size: 14px; box-shadow: -2px 0px 4px 3px rgba(0,0,0,0.06); padding: 50px 25px 25px 25px; transition: all 0.5s ease-in-out; opacity: 0; transform: translateX(100%); transition-delay: 0.2s; display: block; background: #2469f9;background-image: linear-gradient(135deg, #666 10%,#666 100%); background-size: cover; }
    .mobile-lay-close{ background: url(../../assets/img/mclose.png) no-repeat center center; height: 26px; width: 26px; position: fixed; right: 15px; top: 15px; cursor: pointer; z-index: 950; background-size:22px 22px; transition:all 0.5s ease-in-out; opacity:0; display:block; z-index:955; visibility:hidden }
    .mobile-lay dt{position:relative; position:relative;}
    .mobile-a{font-size: 15px;color: #fff;padding: 0 0px 0 6px;display: block;line-height: 46px;border-bottom: 1px solid rgba(255,255,255,0.2);text-transform: uppercase;}

    .mobile-lay-bg.on{opacity:1; visibility:visible; transition-delay:0.2s}
    .mobile-lay.on{opacity:1; transform:translateX(0%); transition-delay:0.4s}
    .mobile-lay-close.on{opacity:1; transform:rotate(180deg);visibility:visible; opacity:1;}
    .mobile-tab{height: 47px;width: 47px;position: absolute;top: 0px;right: 0px;background: url(../../assets/img/mobile_jia.png) no-repeat center center;cursor: pointer;display: none;}


}

@media (max-width:767px){


}


</style>
